/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $( "#featured .feature" ).hover(
          function() {
            $(this).find('img').attr('src', $(this).find('img').attr('data-hover'));
          }, function() {
            $(this).find('img').attr('src', $(this).find('img').attr('data-original'));
          }
        );

        // Check scroll/Add class on navbar
        var nav = $('.navbar');
        var scrolled = false; 
        $(window).scroll(function () {
        if (50 < $(window).scrollTop() && !scrolled) {
            nav.addClass('fixed'); 
            nav.animate({top: 0}, 1000);
            scrolled = true;
          }
          if (50 > $(window).scrollTop() && scrolled) {
            nav.animate({top: -100}, 100, function() {
              nav.removeClass('fixed');
              nav.removeAttr('style');
            });
            scrolled = false;
          }
        }); 


        $(".carousel .carousel-inner .item .carousel-caption h2").html(function(){
          // separate the text by spaces
          var text= $(this).text().split(" ");
          // drop the last word and store it in a variable
          var last = text.pop();
          // join the text back and if it has more than 1 word add the span tag
          // to the last word
          return text.join(" ") + (text.length > 0 ? " <span>"+last+"</span>" : last);   
        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
